export var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["xs"] = 0] = "xs";
    Breakpoint[Breakpoint["sm"] = 600] = "sm";
    Breakpoint[Breakpoint["md"] = 900] = "md";
    Breakpoint[Breakpoint["lg"] = 1200] = "lg";
    Breakpoint[Breakpoint["xl"] = 1536] = "xl";
})(Breakpoint || (Breakpoint = {}));
